export default "__VITE_ASSET__e4bbb5c5__"